import { render, staticRenderFns } from "./PaymentMsgModalB2C.vue?vue&type=template&id=1a8278a4&"
import script from "./PaymentMsgModalB2C.vue?vue&type=script&lang=js&"
export * from "./PaymentMsgModalB2C.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMsgModalB2C.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports